import { useEffect } from 'react'
import { Modal, message } from 'antd'
import { TextLink } from '@weareberyl/design-system'

import { useZoneSetPriorityMutation } from '~/gql/generated/graphql'
import type { SetAnyLoading } from '../useIsAnyLoading'

const confirm = Modal.confirm

const ENABLE_SYMBOL = Symbol('togglePriority')

const onError = () =>
  message.error(
    'Something went wrong when trying to change the priority status',
  )

type SetPriorityProps = {
  id: string
  isPriority: boolean
  setAnyLoading: SetAnyLoading
}

export const SetPriority = ({
  id,
  isPriority,
  setAnyLoading,
}: SetPriorityProps) => {
  const [setZonePriority, { loading }] = useZoneSetPriorityMutation({
    onCompleted: () =>
      message.success(`Bay set to ${isPriority ? 'not' : ''} priority`),
    onError,
    refetchQueries: ['ZoneSummary'],
  })

  const onPress = () => {
    confirm({
      zIndex: 1050,
      title: `${isPriority ? 'Unset' : 'Set'} this bay as priority?`,
      onOk: () => {
        setZonePriority({
          variables: { id, is_priority: Boolean(!isPriority) },
        })
      },
    })
  }

  useEffect(
    () => setAnyLoading(ENABLE_SYMBOL, loading),
    [loading, setAnyLoading],
  )

  return (
    <TextLink
      variant="grape"
      size="small"
      onPress={onPress}
      testID="bay-priority-btn"
    >
      {isPriority ? 'Unset Priority' : 'Set Priority'}
    </TextLink>
  )
}
